<div class="copilot-message-container" *ngIf="followUpQuestions?.length">
  <div class="copilot-message-content">
    <div class="questions-container">
      <br>
      Would you like me to answer any of these questions next?
      <br>
      <br>
      <div class="question-container" [class.selected]="question===selectedQuestion" [class.disabled]="disabled || questionAsked" *ngFor="let question of followUpQuestions">
        <div class="question-content" (click)="sendQuestion(question)">{{ question }}</div>
      </div>
    </div>
    <div class="try-again-container" *ngIf="error">
      <app-button [text]="'Try again'" [class]="'primary'" (click)="tryAgain()">Try again</app-button>
    </div>
  </div>
</div>
